import {
 Label
} from 'shared/components/ui/label';
import {
 Input
} from 'shared/components/ui/input';
import {
 Button
} from 'shared/components/ui/button';
import {
 Plus, Trash2
} from 'lucide-react';
import {
 OutputMapping
} from 'builders/builderOpcode/jsonMode/types';
import OELCodeEditor, {
 OELContext
} from './OELCodeEditor';

const OutputMappingEditor = ({
    output,
    onChange,
    oelContext,
}: {
    output: OutputMapping;
    onChange: (output: OutputMapping) => void;
    oelContext?: OELContext;
}) => {
    const ctx: OELContext = oelContext || {
 inputs: [],
previousStepIds: []
};
    // Convert output object to array of entries for editing
    const entries = Object.entries(output).filter(([key]) => !key.startsWith('x-'));

    const handleAdd = () => {
        const newKey = `output_${entries.length + 1}`;
        onChange({
 ...output,
[newKey]: ''
});
    };

    const handleRemove = (key: string) => {
        const newOutput = {
 ...output
};
        delete newOutput[key];
        onChange(newOutput);
    };

    const handleKeyChange = (oldKey: string, newKey: string) => {
        if (newKey === oldKey) return;
        const newOutput: OutputMapping = {};
        for (const [k, v] of Object.entries(output)) {
            if (k === oldKey) {
                newOutput[newKey] = v;
            } else {
                newOutput[k] = v;
            }
        }
        onChange(newOutput);
    };

    const handleValueChange = (key: string, value: string) => {
        onChange({
 ...output,
[key]: value
});
    };

    return (
        <div className="space-y-3">
            <Label>Output Mapping <span className="text-muted-foreground">(Map step outputs to opcode outputs)</span></Label>

            {entries.length === 0 && (
                <p className="text-sm text-muted-foreground">No outputs defined. Click the button below to add one.</p>
            )}

            <div className="space-y-2">
                {entries.map(([key, value], index) => (
                    <div key={index} className="flex gap-2 items-start">
                        <Input
                            value={key}
                            onChange={(e) => handleKeyChange(key, e.target.value)}
                            placeholder="Output name"
                            className="flex-1 font-mono text-sm"
                        />
                        <span className="text-muted-foreground">=</span>
                        <div className="flex-1">
                            <OELCodeEditor
                                value={typeof value === 'string' ? value : JSON.stringify(value)}
                                onChange={(val) => handleValueChange(key, val)}
                                placeholder="@step_id.output"
                                oelContext={ctx}
                                templateMode={false}
                            />
                        </div>
                        <Button
                            type="button"
                            size="icon"
                            variant="ghost"
                            onClick={() => handleRemove(key)}
                            className="shrink-0"
                        >
                            <Trash2 className="h-4 w-4 text-destructive" />
                        </Button>
                    </div>
                ))}
            </div>

            <Button type="button" size="sm" variant="outline" onClick={handleAdd} className="w-full">
                <Plus className="h-4 w-4 mr-2" />
                Add Output
            </Button>
        </div>
    );
};

export default OutputMappingEditor;
